export default __webpack_public_path__ + "static/media/5.82c863c2.jpg";